export default __webpack_public_path__ + "static/txn-preauthorized-notification-9671f39601dbac469d04b4ba9e6bbfd3.png";